import { FC } from 'react';

interface ToastProps {
  message: string | null;
}

export const Toast: FC<ToastProps> = ({ message }) => {
  if (!message) return null;

  return (
    <>
      <div className="pointer-events-none fixed inset-x-0 bottom-8 z-[100] flex justify-center">
        <div className="animate-fade-in-out rounded-lg bg-gray-800 px-4 py-2 text-sm font-medium text-white shadow-lg">
          {message}
        </div>
      </div>

      <style>{`
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(8px); }
          15% { opacity: 1; transform: translateY(0); }
          75% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-4px); }
        }
        .animate-fade-in-out {
          animation: fadeInOut 1.2s ease-in-out forwards;
        }
      `}</style>
    </>
  );
};
